
import header_experiment_config from "./headers";
import auth from "../../../service/Auth"
import { download_excel } from "../../../service/apis";

const config = window.config;

const getExperimentExcel = async () => {
    //1. Define BODY Post
    const fields =  header_experiment_config.map(x=>x.title);
    const mandatory = header_experiment_config.filter(x => x.mandatory).map(x=>x.title);
    const large_fields = ["Local Experiment ID","Tissue","Library Strategy"];
    const extra_large_fields = ["WGS/Exome Kit"];
    let contents = [];
    if (config.platform === "rdconnect") {
        contents.push(["","TES0001","ERDERA","1", "NO", "Not_Applicable","Whole Blood","WXS","Illumina_NexteraExome_37Mb"]);
        contents.push(["","TES0002","ERDERA","1", "YES", "Not_Applicable","Whole Blood","WXS","Agilent_SureSelect_v7_36Mb"]);
    }
    const excel_name = "step1-experiment.xlsx";
    //2. Body Post
    const data = {
        fields : fields,
        mandatory : mandatory,
        large_fields : large_fields,
        extra_large_fields : extra_large_fields,
        contents : contents,
        excel_name : excel_name
    };
    //3. Call Download Excel API
    await download_excel(auth.getToken(),config.api_endpoint,JSON.stringify(data),excel_name);
}

export default getExperimentExcel;
